import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { fetchClients } from './api';
import { useFonts } from './hooks/useFonts';
import { AppBar } from './components/AppBar/AppBar';
import { ClientList } from './components/ClientList/ClientList';
import { ClientDetail } from './components/ClientDetail/ClientDetail';
import type { Client } from './types';
import SideNav from '../../components/shared/sidenav/SideNav';

export default function ClientBillingAdmin() {
  useFonts();
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState<Client | null>(null);

  useEffect(() => {
    fetchClients().then((data) => {
      console.log('DARA:', data);
      setClients(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="flex-row full-width full-height">
      <SideNav></SideNav>
      <div className="client-main-page full-width flex-column full-height">
        <div className={styles.page}>
          {selected ? (
            <ClientDetail client={selected} onBack={() => setSelected(null)} />
          ) : (
            <ClientList
              clients={clients}
              loading={loading}
              onSelect={setSelected}
            />
          )}
        </div>
      </div>
    </div>
  );
}
